import React from "react";
import { Link } from "react-router-dom";

function PortfolioOne({ picture, title, desc, nav }) {

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <figure className="figure">

      {/* ÜRÜN GÖRSELİ */}
      <a
        href={picture}
        aria-label={`${title} görselini büyüt`}
      >
        <img
          src={picture}
          className="figure-img img-fluid shadow"
          alt={`${title} - Aypin Otomat`}
          title={title}
          loading="lazy"
          decoding="async"
        />
      </a>

      {/* ÜRÜN BAŞLIĞI */}
      <figcaption>
        <Link
          to={nav}
          onClick={scrollToTop}
          aria-label={`${title} detaylarını incele`}
        >
          {title}
        </Link>

        {desc && (
          <p className="mt-2">
            {desc}
          </p>
        )}
      </figcaption>

    </figure>
  );
}

export default PortfolioOne;